document.addEventListener('DOMContentLoaded', () => {
  const hamburger = document.getElementById('hamburger')
  const drawer = document.querySelector('.drawer')
  const body = document.body

  if (hamburger && drawer) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('active')
      drawer.classList.toggle('open')
      body.classList.toggle('no-scroll')
    })

    // Close drawer when clicking a link
    drawer.addEventListener('click', (event) => {
      if (event.target.tagName === 'A') {
        hamburger.classList.remove('active')
        drawer.classList.remove('open')
        body.classList.remove('no-scroll')
      }
    })
  }
})
